// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-tabs-nav {\n}\n\n.ant-tabs-top > .ant-tabs-nav {\n  margin: 0px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/shared/components/CustomTable/style.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".ant-tabs-nav {\n}\n\n.ant-tabs-top > .ant-tabs-nav {\n  margin: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
